import React from "react";
import { TD, TR } from "./styles";
import { DependenteEntidade } from "../../../entidades";

interface Props {
  Dependente: DependenteEntidade
}

export const TBody: React.FC<Props> = ({
  Dependente
}) => {

  return (
    <TR>
      <TD>
        {Dependente.NOME_DEP}
      </TD>
      <TD>
        {Dependente.SEXO_DEP == "F" ? "FEMININO" : "MASCULINO"}
      </TD>
      <TD>
        {Dependente.DT_NASC_DEP}
      </TD>
      <TD>
        {Dependente.DS_GRAU_PARENTESCO}
      </TD>
    </TR>
  );
}